export const MAX_SEARCH_FLIGHT_ITINERARY_COUNT = 6;
